module.exports = __webpack_public_path__ + "img/22599596de024296917f168cab1cf8b6-640.50165335.png";